import { render, staticRenderFns } from "./EventSearchPage.vue?vue&type=template&id=65aa859a&scoped=true"
import script from "./EventSearchPage.vue?vue&type=script&lang=ts"
export * from "./EventSearchPage.vue?vue&type=script&lang=ts"
import style0 from "./EventSearchPage.vue?vue&type=style&index=0&id=65aa859a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aa859a",
  null
  
)

export default component.exports